import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart, registerables } from 'chart.js';

Chart.register(...registerables);

interface LineData {
  label: string;
  data: number[];
  backgroundColor?: string;
  borderColor?: string;
  borderWidth?: number;
}

interface LinearGraphProps {
  title: string;
  xLabels: string[];
  dataSets: LineData[];
  showAllXTicks?: boolean;
}

const LinearGraph: React.FC<LinearGraphProps> = ({ title, xLabels, dataSets, showAllXTicks = false }) => {
  const chartData = {
    labels: xLabels,
    datasets: dataSets,
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: true,
      },
      x: {
        ticks: {
          maxRotation: 45,
          minRotation: 45,
          autoSkip: !showAllXTicks,
        },
      },
    },
  };

  return (
    <div style={{ width: '100%', height: '400px' }}>
      <Line data={chartData} options={options} />
    </div>
  );
};

export default LinearGraph;
